import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import FiverrContext from '../FiverrContext';
import { Variant, Control } from './Variant';

const Experiment = ({ children, test }) => {
    const { abTests = {} } = useContext(FiverrContext);
    const allocation = abTests[test] || 0;
    const isControlOrUnallocated = allocation <= 1;

    return children
        ? React.Children.map(children, (child) => {
            if (child.type === Control) {
                return isControlOrUnallocated ? child : null;
            } else if (child.type === Variant) {
                const v = child.props.v;

                if (typeof v === 'undefined') {
                    return null;
                } else if (v <= 1) {
                    return null;
                } else {
                    return allocation === v ? child : null;
                }
            }

            return null;
        }) : null;
};

Experiment.propTypes = {
    children: PropTypes.node.isRequired,
    test: PropTypes.string.isRequired
};

export {
    Variant,
    Control
};

export default Experiment;
